module.exports = __webpack_public_path__ + "img/shoot_00018.1b5ca993.png";